import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCalendarComponent } from './ngb-calendar.component';
import { SelectModule } from '../select/select.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [CommonModule, FormsModule, NgbModule, SelectModule, SvgIconModule],
  declarations: [NgbCalendarComponent],
  exports: [NgbCalendarComponent],
})
export class NgbCalendarModule {}
